export default function(min, max){
    return Math.floor(Math.random() * max) + min;
}


// WEBPACK FOOTER //
// ./src/utils/getRandomFromRange.js